export default __webpack_public_path__ + "static/media/sweet-couple.4c5cd86e.jpg";